/**
 * A global namespace for `pointerleave` event.
 */
const pointerleaveEvent = 'pointerleave';
export default pointerleaveEvent;
